// TODO: Implement Stripe integration for subscription signup
// This component currently uses placeholder logic (alert/console.log) and needs:
// - Stripe payment form integration
// - Backend API calls for subscription creation
// - Form validation (min/max budget constraints)
// - Error handling and loading states
// - Integration with workspace billing system

import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { X } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useWorkspaceUrl } from '@/hooks/useWorkspaceUrl'

export function SignUpPage() {
	const navigate = useNavigate()
	const workspaceUrl = useWorkspaceUrl()
	const [monthlyBudget, setMonthlyBudget] = useState('5000')

	const handleClose = () => {
		navigate(`${workspaceUrl}/settings#workspace-billing`)
	}

	const handleEnterPaymentInfo = () => {
		// TODO: Navigate to payment flow or open payment modal
		console.log('Monthly budget:', monthlyBudget)
		alert('Payment flow coming soon!')
	}

	const formatCurrency = (value: string) => {
		// Remove non-digits
		const digits = value.replace(/\D/g, '')
		// Format as currency
		return digits ? parseInt(digits).toLocaleString() : ''
	}

	const handleBudgetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const formatted = formatCurrency(e.target.value)
		setMonthlyBudget(formatted)
	}

	return (
		<div className="fixed inset-0 z-50 bg-black/50 flex items-end">
			{/* Full-screen bottom sheet */}
			<div className="w-full bg-background rounded-t-xl shadow-xl animate-in slide-in-from-bottom-full duration-300">
				{/* Header */}
				<div className="flex items-center justify-between p-6 border-b">
					<h1 className="text-2xl font-semibold">Launch Your Campaigns</h1>
					<Button
						variant="ghost"
						size="icon"
						onClick={handleClose}
						className="rounded-full"
					>
						<X className="h-4 w-4" />
					</Button>
				</div>

				{/* Content */}
				<div className="p-8 space-y-8">
					{/* Monthly Budget Input */}
					<div className="space-y-4">
						<Label htmlFor="monthly-budget" className="text-lg font-medium">
							Monthly Budget
						</Label>
						<div className="relative">
							<span className="absolute left-4 top-1/2 -translate-y-1/2 text-2xl font-medium text-muted-foreground">
								$
							</span>
							<Input
								id="monthly-budget"
								type="text"
								value={monthlyBudget}
								onChange={handleBudgetChange}
								placeholder="5,000"
								className="text-2xl font-medium h-16 pl-10 pr-4 text-center"
							/>
						</div>
						<p className="text-sm text-muted-foreground text-center">
							Set your monthly advertising budget to get started
						</p>
					</div>

					{/* Enter Payment Info Button */}
					<div className="flex justify-center pt-4">
						<Button
							onClick={handleEnterPaymentInfo}
							size="lg"
							className="text-lg px-12 py-6 h-auto"
						>
							Enter Payment Info
						</Button>
					</div>
				</div>

				{/* Bottom padding for safe area */}
				<div className="h-8" />
			</div>
		</div>
	)
}
